import clsx from 'clsx';

interface StatusBadgeProps {
  status: string | null | undefined;
}

const statusStyles: Record<string, string> = {
  ACTIVE: 'badge--success',
  LICENSED: 'badge--success',
  SUCCESS: 'badge--success',
  SUSPENDED: 'badge--warning',
  PENDING: 'badge--warning',
  FAILED: 'badge--danger',
  REVOKED: 'badge--danger',
  INACTIVE: 'badge--danger',
  NONE: 'badge--info'
};

export function StatusBadge({ status }: StatusBadgeProps) {
  if (!status) {
    return null;
  }

  const upper = status.toUpperCase();
  const className = statusStyles[upper] ?? 'badge--info';
  const label = upper.replace(/_/g, ' ');

  return <span className={clsx('badge', className)}>{label}</span>;
}

